import axios from 'axios'
import en from 'vee-validate/dist/locale/en'
import fr from 'vee-validate/dist/locale/fr'

export const setLocale = async (locale) => {
  if (!window.loadedLocale.includes(locale)) {
    console.log('LOADING LOCALE')
    const generalLocale = await axios.get(`/locale/general/${locale}.json`)
    window.i18n.setLocaleMessage(locale, generalLocale.data)
    window.Validator.localize({
      fr, en
    })
    const overrideValidationLocale = await axios.get(`/locale/validation/${locale}.json`)
    window.Validator.localize(locale, overrideValidationLocale.data)
    window.loadedLocale.push(locale)
  } else {
    window.Validator.localize(locale)
  }

  window.i18n.locale = locale

  return window.i18n
}
